import { postToTask as ptt } from 'y4/Y4Api';
import _ from 'lodash';
import RT from 'y4/RT';

async function postToTask(task, params) {
  if (!_.endsWith(task, '_CALL_BY_SCRIPT')) {
    return new RT({ id: 69999, message: `No support task:${task} ` });
  } else {
    return await ptt(task, params);
  }
}

export default {
  postToTask
};
